export function isAboveThreshold(
  treshold: number,
  startPosition: number,
  endPosition: number
): boolean {
  return Math.abs(endPosition - startPosition) > treshold;
}
